import { styled } from 'styled-components';

import { RichTextHeadline } from '#/components/Text/RichTextHeadline';

export const CmsThreeStepCtaBlockHeadlineRichText = styled(RichTextHeadline)`
  p {
    line-height: 1.25;
    font-weight: inherit !important;
    margin: 0;
  }
`;

export const CmsThreeStepCtaBlockHeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75em;
  width: 100%;
  margin-bottom: 24px;
`;
